import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import BgImg1 from "../../../images/case-studies/mdrouz/result_back.png";
import Img1 from "../../../images/case-studies/mdrouz/result_mob_img.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Resultcase = () => {
  return (
    <div className="result_back" style={{ backgroundImage: `url(${BgImg1})` }}>
          <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="text-center offset-xl-3 offset-lg-3">
                        <div className="result_head">
                            <h2>The <strong>Results</strong></h2>
                            <p>Mdrouz has successfully transformed the online shopping experience for users in the GCC region. With its user-friendly interface, secure payment options, and personalized features, the app has gained traction among the target audience. The successful integration of Upayment has contributed to the app's reliability and acceptance in the Kuwait market, making Mdrouz a benchmark in multi-vendor ecommerce solutions in the region.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} className="text-center">
                        <div className="result_img">
                        <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="TekRevol" className="img-fluid d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none"
                                />
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Resultcase